import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { LoaderService } from '@frontend/app-config';
import { PublicService } from '../services/public.service';
import {
  GetShowDetails,
  GetShowDetailsError,
  GetShowDetailsSuccess,
  GetTokenDetails,
  GetTokenDetailsError,
  GetTokenDetailsSuccess,
  GenerateRtmToken,
  GenerateRtmTokenError,
  GenerateRtmTokenSuccess,
  GetArtistDetails,
  GetArtistDetailsSuccess,
  GetArtistDetailsError, GetReasons, GetReasonsSuccess, GetReasonsError,
  AddReport,
  AddReportSuccess,
  AddReportError, GetReferralProfileTemplate, GetReferralProfileTemplateSuccess, GetReferralProfileTemplateError,
  GetFaqList, GetFaqListSuccess, GetFaqListError
} from './public.actions';

@Injectable()
export class PublicEffects {
  constructor(
    private actions$: Actions,
    private publicService: PublicService,
    private loaderService: LoaderService
  ) {}


  getTokenDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetTokenDetails),
      switchMap((action) => {
        this.loaderService.show();
        return this.publicService.getToken().pipe(
          map((resp: any) => {
            this.loaderService.hide();
            if (resp.success) {
              return GetTokenDetailsSuccess({tokenDetails: resp.data});
            }
            return GetTokenDetailsError({
              error: this.loaderService.getErrorMessage({
                error: this.loaderService.getErrorMessage(resp),
              }),
            });
          }),
          catchError((error) => {
            this.loaderService.hide();
            return of(
              GetTokenDetailsError({
                error: this.loaderService.getErrorMessage({
                  error: this.loaderService.getErrorMessage(error),
                }),
              })
            );
          })
        );
      })
    )
  );

  getShowDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetShowDetails),
      switchMap((action) => {
        this.loaderService.show();
        return this.publicService.getShowById({params: action.params}).pipe(
          map((resp: any) => {
            this.loaderService.hide();
            if (resp.success) {
              return GetShowDetailsSuccess({showDetails: resp.data});
            }
            return GetShowDetailsError({
              error: this.loaderService.getErrorMessage({
                error: this.loaderService.getErrorMessage(resp),
              }),
            });
          }),
          catchError((error) => {
            this.loaderService.hide();
            return of(
              GetShowDetailsError({
                error: this.loaderService.getErrorMessage({
                  error: this.loaderService.getErrorMessage(error),
                }),
              })
            );
          })
        );
      })
    )
  );

  GenerateRtmTokens$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GenerateRtmToken),
      switchMap((action) => {
        this.loaderService.show();
        return this.publicService.GenerateRtmTokens(action.params).pipe(
          map((resp: any) => {
            this.loaderService.hide();
            if (resp.success) {
              return GenerateRtmTokenSuccess({ rtmToken: resp.data });
            }
            return GenerateRtmTokenError({
              error: this.loaderService.getErrorMessage(resp),
            });
          }),
          catchError((error) => {
            this.loaderService.hide();
            return of(
              GenerateRtmTokenError({
                error: this.loaderService.getErrorMessage(error),
              })
            );
          })
        );
      })
    )
  );

  getArtistDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetArtistDetails),
      switchMap((action) => {
        this.loaderService.show();
        return this.publicService.getArtistDetails(action.artist_id).pipe(
          map((resp: any) => {
            this.loaderService.hide();
            if (resp.success) {
              return GetArtistDetailsSuccess({artistDetails: resp.data});
            }
            return GetArtistDetailsError({
              error: this.loaderService.getErrorMessage({
                error: this.loaderService.getErrorMessage(resp),
              }),
            });
          }),
          catchError((error) => {
            this.loaderService.hide();
            return of(
              GetArtistDetailsError({
                error: this.loaderService.getErrorMessage({
                  error: this.loaderService.getErrorMessage(error),
                }),
              })
            );
          })
        );
      })
    )
  );

  getReasons$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetReasons),
      switchMap((action) => {
        this.loaderService.show();
        return this.publicService.getReasons().pipe(
          map((resp: any) => {
            this.loaderService.hide();
            if (resp.success) {
              return GetReasonsSuccess({reasonsList: resp.data});
            }
            return GetReasonsError({
              error: this.loaderService.getErrorMessage({
                error: this.loaderService.getErrorMessage(resp),
              }),
            });
          }),
          catchError((error) => {
            this.loaderService.hide();
            return of(
              GetReasonsError({
                error: this.loaderService.getErrorMessage({
                  error: this.loaderService.getErrorMessage(error),
                }),
              })
            );
          })
        );
      })
    )
  );
  addReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddReport),
      switchMap((action) => {
        this.loaderService.show();
        return this.publicService.contactUs(action.report).pipe(
          map((resp: any) => {
            this.loaderService.hide();
            if (resp.success) {
              return AddReportSuccess({report: resp.data});
            }
            return AddReportError({
              error: this.loaderService.getErrorMessage({
                error: this.loaderService.getErrorMessage(resp),
              }),
            });
          }),
          catchError((error) => {
            this.loaderService.hide();
            return of(
              AddReportError({
                error: this.loaderService.getErrorMessage({
                  error: this.loaderService.getErrorMessage(error),
                }),
              })
            );
          })
        );
      })
    )
  );

  getReferralProfileTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetReferralProfileTemplate),
      switchMap((action) => {
        this.loaderService.show();
        return this.publicService.getReferralProfileTemplate(action.code).pipe(
          map((resp: any) => {
            this.loaderService.hide();
            if (resp.success) {
              return GetReferralProfileTemplateSuccess({ invite: resp.data });
            }
            return GetReferralProfileTemplateError({
              error: this.loaderService.getErrorMessage({
                error: this.loaderService.getErrorMessage(resp),
              }),
            });
          }),
          catchError((error) => {
            this.loaderService.hide();
            return of(
              GetReferralProfileTemplateError({
                error: this.loaderService.getErrorMessage({
                  error: this.loaderService.getErrorMessage(error),
                }),
              })
            );
          })
        );
      })
    )
  );

  getFaqList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetFaqList),
      switchMap(() => {
        this.loaderService.show();
        return this.publicService.getFaqList().pipe(
          map((resp: any) => {
            this.loaderService.hide();
            if (resp.success) {
              return GetFaqListSuccess({ faqList: resp.data });
            }
            return GetFaqListError({
              error: this.loaderService.getErrorMessage(resp),
            });
          }),
          catchError((error) => {
            this.loaderService.hide();
            return of(
              GetFaqListError({
                error: this.loaderService.getErrorMessage(error),
              })
            );
          })
        );
      })
    )
  );

}
